import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JobClient } from '@models/models';
import { Location } from '@angular/common';

@Component({
	selector: 'job-client',
	template: require('./job-client.html'),
	styles: [require('./job-client.scss')]
})
export class JobClientComponent {
	@Input() client: JobClient;
	@Input() type: string;
	@Input() archived: boolean;
	@Output() onEdit: EventEmitter<any> = new EventEmitter();
	@Output() onSend: EventEmitter<JobClient> = new EventEmitter();
	@Output() onClientUpdate: EventEmitter<any> = new EventEmitter();

	constructor(private location: Location) {}

	editClient(): void {
		this.onEdit.emit();
	}

	sendEmail(): void {
		this.onSend.emit(this.client);
	}

	handleClick(e, clientId: number): void {
		let clickedEl = e.target;

		while (
			!clickedEl.className.includes('not-clickable') &&
			!clickedEl.className.includes('client-section')
		) {
			clickedEl = clickedEl.parentNode;
		}

		if (!clickedEl.className.includes('not-clickable')) {
			this.location.go(`/clients/client${clientId}`);
			e.stopImmediatePropagation();
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/client/job-client/job-client.ts